export const getters = {
  isSubscriptionExist: state => title => state.subscriptions.some((s) => s.title === title),
};
